import * as CryptoJS from 'crypto-js';
import { env } from '@/config/env';

const encryptionKey = env.baseUrl;

export const encrypt = (data: string): string => {
    try {
        return CryptoJS.AES.encrypt(data, encryptionKey).toString();
    } catch (error) {
        console.error("Encryption error:", error);
        return '';
    }
};

export const decrypt = (data: string): any => {
    try {
        const bytes = CryptoJS.AES.decrypt(data, encryptionKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        try {
            return JSON.parse(decryptedData)
        } catch {
            return decryptedData
        }
    } catch (error) {
        console.error("Decryption error:", error);
        return null;
    }
};
